import 'css-chunk:src/applications/ReportsApp/pages/Home/components/MetricsSecondary/MetricsSecondary.scss';export default {
  "statistic": "_statistic_cvsmo_1"
};